import axios from '../../helpers/http';
import { mapArrayToObj } from '../../helpers/utils';
const { VUE_APP_SERVER_BASE_URL: BASE_URL } = process.env;

const INITIAL_STATE = {
  isSubmitting: false,
  isLoading: false,
  errors: {},
  agentDrafts: {
    data: {},
    pages: 0,
  },
  agentSales: {
    data: {},
    counter: null,
    pages: 0,
  },
  companySales: {
    data: {},
    count: null,
    pages: 0,
  },
};

const actions = {
  saveRecord: ({ commit, rootState }, data) => {
    const { currentUser } = rootState.auth;
    commit('SUBMITTING_RECORD');
    return axios
      .post(`${BASE_URL}/companies/${currentUser.companyId}/sales`, data)
      .then((res) => {
        const data = res.data;
        commit('SAVING_NEW_RECORD_COMPLETE', data);
        return data;
      })
      .catch((error) => {
        commit('SAVING_NEW_RECORD_FAILED', error);
        throw error;
      });
  },
  fetchAgentSales: (
    { commit, rootState },
    { mutation, type = '', page, limit, search }
  ) => {
    const {
      currentUser: { companyId, id },
    } = rootState.auth;
    let ACTION_URL = `/companies/${companyId}/users/${id}/sales?type=${type}&page=${page}&limit=${limit}`;
    if (search) {
      ACTION_URL = `${ACTION_URL}&search=${search}`;
    }
    return axios
      .get(ACTION_URL)
      .then((res) => {
        const { count, rows } = res.data;
        const data = mapArrayToObj(rows);
        commit(mutation, {
          data,
          count,
          pages: Math.ceil(count / limit || count / 50),
        });
        return sales;
      })
      .catch(() => {
        commit('SET_LOADING_STATE', false);
        return false;
      });
  },

  fetchCompanySales: (
    { commit, rootState },
    { page = 1, limit = 50, search, agentId } = {}
  ) => {
    commit('SET_LOADING_STATE', true);
    const {
      currentUser: { companyId },
    } = rootState.auth;
    let ACTION_URL = `${BASE_URL}/companies/${companyId}/sales?page=${page}&limit=${limit}`;
    if (search) {
      ACTION_URL += `&search=${search}`;
    }
    if (agentId) {
      ACTION_URL += `&agentId=${agentId}`;
    }
    return axios
      .get(ACTION_URL)
      .then((res) => {
        const { count, rows } = res.data;
        const data = mapArrayToObj(rows);
        commit('SET_COMPANY_SALES', {
          data,
          pages: Math.ceil(count / limit),
          count,
        });
        return sales;
      })
      .catch(() => {
        commit('SET_LOADING_STATE', false);
      });
  },
  getDrafts: ({ commit, dispatch }, { page = 1, limit = 50, search } = {}) => {
    commit('SET_LOADING_STATE', true);
    return dispatch('fetchAgentSales', {
      mutation: 'SET_AGENT_DRAFTS',
      type: 'editable',
      page,
      limit,
      search,
    });
  },
  getSales: ({ commit, dispatch }, { page = 1, limit = 50, search } = {}) => {
    commit('SET_LOADING_STATE', true);
    return dispatch('fetchAgentSales', {
      mutation: 'SET_AGENT_SALES',
      page,
      limit,
      search,
    });
  },
  editSalesItem: async ({ dispatch, rootState }, data) => {
    const {
      currentUser: { id, companyId },
    } = rootState.auth;
    const { data: response } = await axios.put(
      `${BASE_URL}/companies/${companyId}/users/${id}/sales/${data.id}`,
      data
    );
    dispatch('getDrafts');
    return response;
  },
  deleteSalesItem: async ({ dispatch, rootState }, id) => {
    const {
      currentUser: { id: userId, companyId },
    } = rootState.auth;
    await axios.delete(
      `${BASE_URL}/companies/${companyId}/users/${userId}/sales/${id}`
    );
    dispatch('getDrafts');
  },
  revertToDraft: async ({ dispatch, rootState }, id) => {
    const {
      currentUser: { companyId },
    } = rootState.auth;
    await axios.put(`${BASE_URL}/companies/${companyId}/sales/${id}/reverts`);
    dispatch('fetchCompanySales');
  },
  editItem: async ({ dispatch, rootState }, data) => {
    const {
      currentUser: { id: userId },
    } = rootState.auth;
    const item = { ...data, id: undefined };
    const response = await axios.put(
      `${BASE_URL}/users/${userId}/items/${data.id}`,
      item
    );
    dispatch('getDrafts');
    return response;
  },
};

const mutations = {
  SUBMITTING_RECORD(state) {
    state.isSubmitting = true;
  },
  SAVING_NEW_RECORD_COMPLETE(state, data) {
    state.isSubmitting = false;
    if (data.editable) {
      state.drafts = { [data.id]: data, ...state.drafts };
    } else {
      state.sales = { [data.id]: data, ...state.sales };
    }
  },
  SAVING_NEW_RECORD_FAILED(state, errors) {
    state.isSubmitting = false;
    state.errors = errors;
  },
  SET_LOADING_STATE(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_AGENT_DRAFTS(state, data) {
    state.isLoading = false;
    state.agentDrafts = data;
  },
  SET_AGENT_SALES(state, data) {
    state.isLoading = false;
    state.agentSales = data;
  },
  SET_COMPANY_SALES(state, data) {
    state.isLoading = false;
    state.companySales = data;
  },
};

const getters = {
  isSubmitting: (state) => state.isSubmitting,
  agentDrafts: (state) => state.agentDrafts,
  agentSales: (state) => state.agentSales,
  companySales: (state) => state.companySales,
  isLoading: (state) => state.isLoading,
};

export const sales = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: INITIAL_STATE,
};
